import { DatosPersonales } from '../models/perfil.models';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const RUN_REGEX = /^[A-Za-z0-9.\-]{6,20}$/;
const TELEFONO_REGEX = /^[+0-9()\s-]{8,20}$/;

/** Solo formato de lo que el usuario ya escribió. Guardar y continuar no exige completar el bloque. */
export function validarFormatoPerfil(data: DatosPersonales): Partial<Record<string, string>> {
  const errores: Partial<Record<string, string>> = {};

  if (data.correoPrincipal && !EMAIL_REGEX.test(data.correoPrincipal)) {
    errores['correoPrincipal'] = 'Correo principal invalido.';
  }
  if (data.correoAlternativo && !EMAIL_REGEX.test(data.correoAlternativo)) {
    errores['correoAlternativo'] = 'Correo alternativo invalido.';
  }
  if (data.runPasaporte && !RUN_REGEX.test(data.runPasaporte)) {
    errores['runPasaporte'] = 'RUN/pasaporte invalido.';
  }
  if (data.telefono && !TELEFONO_REGEX.test(data.telefono)) {
    errores['telefono'] = 'Telefono invalido.';
  }

  return errores;
}

/** @deprecated Usar validarFormatoPerfil: Mi perfil ya no bloquea el guardado por campos vacios. */
export function validarDatosPersonales(data: DatosPersonales): Partial<Record<keyof DatosPersonales, string>> {
  return validarFormatoPerfil(data) as Partial<Record<keyof DatosPersonales, string>>;
}
